import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { registerAdmin } from "../../../services/AdminService";
import { useAxiosInstance } from "../../../services/Interceptor";
import { useDispatch, useSelector } from "react-redux";
import { adminLoading, adminError } from "../../../store/slices/adminSlice";
import Nav from "../../../components/Nav";

const AdminRegistering = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const apiInstance = useAxiosInstance();
  const r_admin = useSelector((state) => state.admin);
  const { error, loading } = r_admin;
  const [data, setData] = useState();

  useEffect(() => {
    setData({
      email: searchParams.get("email"),
      token: searchParams.get("register_token"),
      expiration: searchParams.get("token_expiration"),
    });
  }, [searchParams, dispatch]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(adminLoading(true));
    dispatch(adminError(null));
    if (data.password !== data.confirmPassword) {
      dispatch(adminError("Passwords do not match"));
      dispatch(adminLoading(false));
      return;
    }
    try {
      await registerAdmin(apiInstance, data);
      navigate("/sign-in");
    } catch (err) {
      dispatch(adminError("Registration failed. Please try again."));
    } finally {
      dispatch(adminLoading(false));
    }
  };

  const handleChange = (event) => {
    setData({
      ...data,
      [event.target.name]: event.target.value,
    });
  };

  return (
    data && (
      <div className="hero-bg h-full">
        <Nav />
        <div className="flex flex-col items-center mt-24 min-h-screen ">
          <div className="bg-white bg-opacity-60 p-6 rounded-lg shadow-lg w-full max-w-md">
            <h1 className="text-xl font-bold text-center text-gray-900 mb-6">
              REGISTER AS ADMIN
            </h1>
            {error && <p className="text-red-500 text-center mb-4">{error}</p>}
            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label className="block text-gray-700 text-xl mb-2">
                  Email
                </label>
                <input
                  type="email"
                  value={data.email}
                  readOnly
                  className="w-full p-3 border rounded bg-gray-200 text-gray-800 cursor-not-allowed focus:outline-none"
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700 font-medium mb-2 text-xl">
                  Set Password
                </label>
                <input
                  type="password"
                  onChange={handleChange}
                  name="password"
                  required
                  className="w-full p-3 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                  maxLength={16}
                  minLength={8}
                />
              </div>
              <div className="mb-6">
                <label className="block text-gray-700 font-medium mb-2 text-xl">
                  Confirm Password
                </label>
                <input
                  type="password"
                  name="confirmPassword"
                  onChange={handleChange}
                  required
                  className="w-full p-3 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                  maxLength={16}
                  minLength={8}
                />
              </div>
              <button
                type="submit"
                className="w-full bg-red-600 text-white py-3 rounded hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                disabled={loading}
              >
                {loading ? "Registering..." : "Register"}{" "}
              </button>
            </form>
          </div>
        </div>
      </div>
    )
  );
};
export default AdminRegistering;
